import AboutCrazy from "./AboutCrazy"

export default AboutCrazy